<template>
  <ul v-if="result" pagination>
    <li :class="{disabled: pageNow < 2}">
      <a @click="first">&lt;&lt;</a>
    </li>
    <li :class="{disabled: pageNow < 2}">
      <a @click="prev">&lt;</a>
    </li>
    <li v-for="page in pageList()" :key="page" :class="{active: page === pageNow }" @click="$emit('go', page)">
      <a>{{ page }}</a>
    </li>
    <li :class="{disabled: totalPages === pageNow}">
      <a @click="next">&gt;</a>
    </li>
    <li :class="{disabled: totalPages === pageNow}">
      <a @click="end">&gt;&gt;</a>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    result: { type: Object, default: null },
  },
  data() {
    return {
      totalPages: 0,
      pageNow: 0,
      pageStart: 0,
      pageEnd: 0,
    };
  },
  methods: {
    first() {
      if (this.pageNow === 1) return;
      this.$emit('go', 1);
    },
    prev() {
      if (this.pageNow === 1) return;
      this.$emit('go', this.pageNow - 1);
    },
    next() {
      if (this.pageNow === this.totalPages) return;
      this.$emit('go', this.pageNow + 1);
    },
    end() {
      if (this.pageNow === this.totalPages) return;
      this.$emit('go', this.totalPages);
    },
    pageList() {
      const result = [];
      if (!this.$props) {
        result.push(1);
        return result;
      }
      if (this.$props.result) {
        const data = this.$props.result;
        const len = 5;
        const c = data.pageNo;
        const t = data.pageCount;
        const s = (Math.floor(c / len) * len) + 1;
        const e = s + (t - s > len - 1 ? len - 1 : t - s);
        this.pageNow = c;
        this.totalPages = t;
        this.pageStart = s;
        this.pageEnd = e;
        for (let i = s; i <= e; i += 1) result.push(i);
      } else {
        this.pageNow = 0;
        this.totalPages = 0;
        this.pageStart = 0;
        this.pageEnd = 0;
        result.push(1);
      }
      return result;
    },
  },
};
</script>
<style lang="less" scoped>
  @import "../../less/asset";
  @import "../../less/gynpad";

  [pagination] { .ib; .ib-list; }
  [pagination] > li { .gap-h(5px); .border(#aaa); .p-h(5px); min-width: 25px; }
  [pagination] > li.active a { color: @c-pink; }
  [pagination] > li.disabled a { cursor: default; opacity: 1; }
  [pagination] > li.disabled a { opacity: 0.3; }
</style>



// WEBPACK FOOTER //
// src/components/admin/pagination.vue